import styled from "styled-components";
import { breakpoints, heightBreakpoints } from "../../styles/breakpoints";
import { hexToRgba } from "../../utils/hexToRGBA";

export const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 40rem 1fr 5rem;
  height: 100%;
  width: 100%;
  grid-column: 1/-1;
  grid-row: 1/-1;

  ${({ $viewport }) => {
    if (!$viewport) return ""; // Add this check to prevent errors when viewport is undefined
    const { width, height } = $viewport;
    const isLandscape = width > height;

    if (width <= breakpoints.mobileS) {
      return `
        grid-template-columns: ${isLandscape ? "1fr 1fr" : "1fr"};
        grid-template-rows: ${isLandscape ? "1fr" : "auto 1fr"};
        ${isLandscape ? "grid-auto-flow: column;" : ""}
      `;
    }
    if (width <= breakpoints.mobileM) {
      return `
    grid-template-columns: ${isLandscape ? "1fr 1fr" : "1fr"};
    grid-template-rows: ${isLandscape ? "1fr" : "auto 1fr"};
    ${isLandscape ? "grid-auto-flow: column;" : ""}
  `;
    }
    if (width <= breakpoints.mobileL) {
      return `
    grid-template-columns: ${isLandscape ? "1fr 1fr 1fr" : "1fr"};
    grid-template-rows: ${isLandscape ? "1fr" : "auto 1fr auto"};
    ${isLandscape ? "grid-auto-flow: column;" : ""}
  `;
    }
    if (width <= breakpoints.tabletS) {
      return `
    grid-template-columns: ${isLandscape ? "1fr 1fr 1fr" : "1fr 1fr"};
    grid-template-rows: ${isLandscape ? "1fr 1fr" : "auto 1fr auto"};
    ${isLandscape ? "grid-auto-flow: column;" : ""}
  `;
    }
    if (width <= breakpoints.tabletM) {
      return `
    grid-template-columns: ${isLandscape ? "1fr 1fr 1fr 1fr" : "1fr 1fr"};
    grid-template-rows: ${isLandscape ? "1fr 1fr" : "auto 1fr auto"};
    ${isLandscape ? "grid-auto-flow: column;" : ""}
  `;
    }
    if (width <= breakpoints.tabletL) {
      return `
    grid-template-columns: ${isLandscape ? "1fr 1fr 1fr 1fr" : "1fr 1fr 1fr"};
    grid-template-rows: ${isLandscape ? "1fr 1fr 1fr" : "auto 1fr auto"};
    ${isLandscape ? "grid-auto-flow: column;" : ""}
  `;
    }
    if (width <= breakpoints.laptopS) {
      return `
        grid-template-columns: 5.25rem 1fr;
      `;
    }
    if (width <= breakpoints.laptopL) {
      return `
        grid-template-columns: 5.25rem 1fr;
      `;
    }
    if (width <= breakpoints.desktop) {
      return `
        grid-template-columns: 30rem 1fr 5rem;
      `;
    }
    if (width <= breakpoints.desktopL) {
      return `
        grid-template-columns: 40rem 1fr 5rem;
      `;
    }
  }}
`;

export const ContentArea = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 5.25rem 1fr 5.25rem;
  grid-column: 2/-1;
  grid-row: 1/-1;
  z-index: 1900;
  pointer-events: auto;
  align-items: center;

  ${({ $viewport }) => {
    if (!$viewport) return ""; // Add this check to prevent errors when viewport is undefined
    const { width, height, isLandscape } = $viewport;

    if (width <= breakpoints.mobileS) {
      return `
        grid-template-rows: 3rem 1fr;
        grid-template-columns: 1fr 2.5rem;
        padding: 0;
      `;
    } else if (width <= breakpoints.mobileM) {
      return `
        grid-template-rows: 3rem 1fr;
        grid-template-columns: 1fr 2.5rem;
        padding: 0;
      `;
    } else if (width <= breakpoints.mobileL) {
      return `
        grid-template-rows: 3rem 1fr;
        grid-template-columns: 1fr 2.5rem;
        padding: 0;
      `;
    } else if (width <= breakpoints.tabletS) {
      return `
        grid-template-rows: 3.5rem 1fr;
        grid-template-columns: 1fr 2.5rem;
        padding: 0;
      `;
    } else if (width <= breakpoints.tabletM) {
      return `
        grid-template-rows: ${isLandscape ? `2.75rem 1fr` : `3.5rem 1fr`};
        grid-template-columns: 1fr 2.5rem;
        padding: 0;
      `;
    } else if (width <= breakpoints.tabletL) {
      return `
        grid-template-rows: ${isLandscape ? `2.75rem 1fr` : `3.5rem 1fr`};
        grid-template-columns: ${isLandscape ? `1fr 2.5rem` : `1fr 2.5rem`};
        padding: 0;
      `;
    } else if (width <= breakpoints.laptopS) {
      return `
        grid-template-rows: 5.25rem 1fr;
        grid-template-columns: 1fr 2.5rem;
        padding: 0;
        grid-column: 2/-1;
      `;
    } else if (width <= breakpoints.laptopL) {
      return `
        grid-template-rows: 5.25rem 1fr;
        grid-template-columns: 1fr 3.5rem;
        padding: 0;
        grid-column: 2/-1;
      `;
    } else if (width <= breakpoints.desktop) {
      return `
        grid-template-rows: 5.25rem 1fr 5.25rem;
        grid-template-columns: 1fr 5.25rem;
      `;
    } else if (width <= breakpoints.desktopL) {
      return `
        grid-template-rows: 5.25rem 1fr 5.25rem;
        grid-template-columns: 1fr 5.25rem;
      `;
    }
  }}
`;

export const GlassOverlay = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  height: 100%;
  grid-column: 1/-1;
  grid-row: 1/-1;
  grid-template-columns: 35.5rem 1fr 5.25rem;
  grid-template-rows: 5.25rem 1fr 5.25rem;
  background: ${({ theme }) => hexToRgba(theme.bodyBgSecondary, 0.25)};
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  margin: 0 auto;
  z-index: 900;

  ${({ $viewport }) => {
    const { width, isLandscape } = $viewport;

    if (width <= breakpoints.mobileS) {
      return `
        grid-template-columns: 3rem 1fr;
        grid-template-rows: 3em 1fr 3rem;
      `;
    }
    if (width <= breakpoints.mobileM) {
      return `
        grid-template-columns: 3rem 1fr;
        grid-template-rows: 3em 1fr 3rem;
      `;
    }
    if (width <= breakpoints.mobileL) {
      return `
        grid-template-columns: 3rem 1fr;
        grid-template-rows: 3em 1fr;

      `;
    }
    if (width <= breakpoints.tabletS) {
      return `
        grid-template-columns: 3.5rem 1fr;
        grid-template-rows: 3.5em 1fr;
      `;
    }
    if (width <= breakpoints.tabletM) {
      return `
        grid-template-columns: 3.5rem 1fr;
        grid-template-rows: 3.5em 1fr 3.5rem;

        ${
          isLandscape
            ? `
              grid-template-columns: 17.5rem 1fr;
              grid-template-rows: 2.75em 1fr 2.75rem;
            `
            : ""
        }
      `;
    }
    if (width <= breakpoints.tabletL) {
      return `
        grid-template-columns: 3.5rem 1fr;
        grid-template-rows: 3.5em 1fr 3.5rem;

        ${
          isLandscape
            ? `
              grid-template-columns: 20rem 1fr;
              grid-template-rows: 2.75em 1fr 2.75rem;
            `
            : ""
        }
      `;
    }

    if (width <= breakpoints.laptopS) {
      return `
        grid-template-columns: 25rem 1fr 5.25rem;

        ${
          isLandscape
            ? `
              grid-template-columns: 25.5rem 1fr 3.5rem;
              grid-template-rows: 2.75em 1fr 2.75rem;
            `
            : ""
        }
      `;
    }
    if (width <= breakpoints.laptopM) {
      return `
        grid-template-columns: 25rem 1fr 5.25rem;

      `;
    }
    if (width <= breakpoints.laptopL) {
      return `
        grid-template-columns: 30rem 1fr 5.25rem;

      `;
    }
    if (width <= breakpoints.desktop) {
      return `
        grid-template-columns: 30rem 1fr 3.5rem;
        grid-template-rows: 5.25rem 1fr;
      `;
    }
    if (width <= breakpoints.desktopL) {
      return `
        grid-template-columns: 32.5rem 1fr 5.25rem;

      `;
    }
  }}
`;
